<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Installation Ceremony </h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="">
    <div class="section-lg">
        <div class="container">
            <div class="text-justify">
                <p>The Installation Ceremony at GHRSTU, Nagpur and GHRCACS, Nagpur symbolised fresh responsibilities,
                    shared vision, and a commitment to collective growth.</p>
            </div>
            <div class="row mb-20 mt-5 mb-4">
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-3.webp"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-3.webp"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-4.webp"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-4.webp"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-5.webp"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-5.webp"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-6.webp"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-6.webp"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-7.webp"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-7.webp"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-8.webp"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-8.webp"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-9.webp"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-9.webp"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                 <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-10.webp"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony-10.webp"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
            </div>

            <div class="text-justify">
                <p>GHRCACS, Nagpur, successfully conducted the installation program for the Rotaract Club and NSS. Mr
                    Nikhil Chandwani, the Guest of Honour, inspired students with his insights, encouraging leadership,
                    service, and community engagement.</p>
            </div>
            <div class="row mb-20 mt-5">
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony2.avif"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony2.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony3.avif"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony3.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony4.avif"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony4.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony5.avif"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony5.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony6.avif"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony6.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony7.avif"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony7.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
                <div class="col-md-3 col-6">
                    <div class="gallery-item" data-aos="zoom-in-down">
                        <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony8.avif"
                            data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                            <img class="img-fluid"
                                src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/installation-ceremony8.avif"
                                alt="Events | Ghrcacsn" title="Events | Ghrcacsn">
                            <div class="gallery-overlay"></div>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>